// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageto{
    width: fit-content;
    border-radius: 18px 18px 18px 0px;
    word-wrap: break-word;
    background-color: #b1c2bc;
    padding: 8px;
    max-width: 100%;
    min-width: 15%;
  
}
.messagefrom{
    width: fit-content;
    border-radius: 18px 18px 0px 18px;
    word-wrap: break-word;
    background-color: #1d8864;
    padding: 8px;
    max-width: 100%;
    float: right;
    min-width: 15%;
}

.userinfo{
    display: flex;
    justify-content: space-between;
    background: aliceblue;
    padding: 10px;
    border-radius: 10px;
}
.modal-content {
  
    margin: 0 auto;
    height: auto;
}
.chatBody{
    padding: 10px;
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
}

.pagination .page-item .page-link {
    padding: inherit;
}




`, "",{"version":3,"sources":["webpack://./src/views/liveChat/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,cAAc;;AAElB;AACA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;AACA;;IAEI,cAAc;IACd,YAAY;AAChB;AACA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".messageto{\n    width: fit-content;\n    border-radius: 18px 18px 18px 0px;\n    word-wrap: break-word;\n    background-color: #b1c2bc;\n    padding: 8px;\n    max-width: 100%;\n    min-width: 15%;\n  \n}\n.messagefrom{\n    width: fit-content;\n    border-radius: 18px 18px 0px 18px;\n    word-wrap: break-word;\n    background-color: #1d8864;\n    padding: 8px;\n    max-width: 100%;\n    float: right;\n    min-width: 15%;\n}\n\n.userinfo{\n    display: flex;\n    justify-content: space-between;\n    background: aliceblue;\n    padding: 10px;\n    border-radius: 10px;\n}\n.modal-content {\n  \n    margin: 0 auto;\n    height: auto;\n}\n.chatBody{\n    padding: 10px;\n    height: 500px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.pagination .page-item .page-link {\n    padding: inherit;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
